import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { SitemapEntities } from 'client/data/models/sitemap';
import { SitemapLink } from 'site-modules/sitemap/components/sitemap-link/sitemap-link';

export function SitemapLinksList({ category = '', links = [], pathname = '' }) {
  return (
    <Fragment>
      {category && <h2 className="size-16 fw-bold text-gray-darker">{category}</h2>}
      <ul className="sitemap-links-list list-unstyled">
        {links.map(link => (
          <li key={link.href || link.location} className="size-16">
            <SitemapLink link={link} pathname={pathname} />
          </li>
        ))}
      </ul>
    </Fragment>
  );
}

SitemapLinksList.propTypes = {
  category: PropTypes.string,
  links: PropTypes.arrayOf(SitemapEntities.SitemapLink),
  pathname: PropTypes.string,
};
